import { writable, derived } from 'svelte/store';
import { gameInitGet, isStartF, playerNameGet, playerColorGet } from './store_common';
import User from '../model/User';

export let user = writable(new User());
export const game = writable(gameInitGet());
 
export const isStart = derived([user, game], isStartF);
export const playerName = derived([user, game], playerNameGet);
export const playerColor = derived([user, game], playerColorGet);

